import { type ReactNode } from 'react'
import Image from 'next/image'
import { useTranslation } from '@mc/i18n'
import { SubscriptionSignUpCTA } from 'pages/certificates/components'
import { LearnMoreLink } from 'pages/certificates/experiments/mccerts-2548_v1-subscriptions-entry-point'
import { MCCERTS_2972_SUBS_ONLY_CLP_I18N_NAMESPACE } from './i18n'
import {
  PASS_PARTNER_LOGO_HEIGHT,
  PASS_PARTNER_LOGOS,
} from './passPartnerLogos'

type PassOnlyHeroModuleProps = {
  // Price treatment under the eyebrow; omit it for the no-price arm.
  priceLockup?: ReactNode
  logosAboveCta?: boolean
}

export const PassOnlyHeroModule = ({
  priceLockup,
  logosAboveCta = false,
}: PassOnlyHeroModuleProps) => {
  const { t } = useTranslation(MCCERTS_2972_SUBS_ONLY_CLP_I18N_NAMESPACE)

  const partnerLogos = (
    <ul
      aria-label={t('passOnlyHero.partnersLabel')}
      className='flex flex-wrap items-center justify-center gap-5'
    >
      {PASS_PARTNER_LOGOS.map((partner) => (
        <li key={partner.name}>
          <Image
            className='h-[24px] w-auto lg:h-[30px]'
            src={partner.src}
            alt={partner.name}
            height={PASS_PARTNER_LOGO_HEIGHT}
            width={Math.round(
              (partner.width * PASS_PARTNER_LOGO_HEIGHT) / partner.height,
            )}
          />
        </li>
      ))}
    </ul>
  )

  return (
    <div className='flex w-full flex-col items-center gap-4 rounded-[20px] bg-c-base-100 p-5 text-center lg:gap-5'>
      <div className='flex w-full flex-col items-center gap-3'>
        <p className='c-caption-mono text-c-text-tint-3'>
          {t('passOnlyHero.eyebrow')}
        </p>
        {priceLockup}
        {logosAboveCta && partnerLogos}
      </div>
      <div className='flex w-full flex-col items-center gap-3'>
        <SubscriptionSignUpCTA />
        <p className='c-body-small text-c-text-tint-3'>
          {t('passOnlyHero.guarantee')}
          <br />
          <LearnMoreLink>{t('passOnlyHero.learnMore')}</LearnMoreLink>
        </p>
        {!logosAboveCta && partnerLogos}
      </div>
    </div>
  )
}
